import { render, staticRenderFns } from "./Automotive.vue?vue&type=template&id=a06788d2&"
import script from "./Automotive.vue?vue&type=script&lang=js&"
export * from "./Automotive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Automotive.vue"
export default component.exports